import { Helmet } from 'react-helmet-async';

export default function ModerateCommentsPage() {
  return (
    <div style={{ padding: '20px' }}>
      <Helmet>
        <title>Moderate Comments - QuestFlow Admin</title>
      </Helmet>
      <h1>Moderate Comments</h1>
      <p>Comment moderation - Coming soon</p>
    </div>
  );
}
